export default __webpack_public_path__ + "static/media/GPA_1920x600webbanner_GMletter.cdcf5248.png";